import React from 'react';

import "assets/scss/components/filters/filtersWrapper.scss";
import { Button } from 'components/buttons/Button';


function FiltersWrapper({
    isFiltering,
    isDisabled,
    submitDisabledMsg, clearDisabledMsg,
    onSubmit, onClear,
    children
}) {
    return (
        <div className={"component-filters-wrapper d-flex flex-wrap"}>
            <div className={"component-filter-wrapper__children d-flex flex-wrap"}>
                {children}
            </div>

            <div className={"component-filters-wrapper__finalize-actions d-flex align-items-center"}>
                {/* Submit */}
                <Button
                    className={"finalize-actions__submit"}
                    handleOnClick={onSubmit}
                    isLoading={isFiltering}
                    isDisabled={isDisabled}
                    disabledMsg={submitDisabledMsg}
                >
                    Search
                </Button>

                {/* Clear */}
                <Button
                    className={"finalize-actions__clear"}
                    handleOnClick={onClear}
                    isDisabled={isDisabled}
                    disabledMsg={clearDisabledMsg}
                    isDecoration_lightTransparent
                >
                    Clear
                </Button>
            </div>
        </div>
    );
}

export default FiltersWrapper;